import {
  Box,
  HStack,
  IconButton,
  Select,
  Text,
  Tooltip,
  useToast,
} from "@chakra-ui/react";
import { FaChevronCircleDown } from "react-icons/fa";
import { useState } from "react";

const RegisterEntrySelect = ({
  registers,
  registerLoading,
  setSignalDataArray,
}) => {
  const toast = useToast();
  const [selectedRegisterId, setSelectedRegisterId] = useState("");
  const [selectedEntryId, setSelectedEntryId] = useState("");

  const handleSelectTemplate = async () => {
    console.log("🔍 Select Template clicked");

    try {
      const url = `https://registers.poc.mrc.ai/api/registers/${selectedRegisterId}`;
      const res = await fetch(url);
      if (!res.ok) throw new Error("Failed to fetch full register");

      const fullRegister = await res.json();
      console.log("📘 Full Register fetched:", fullRegister);

      const fullEntry = fullRegister.entries.find(
        (entry) => entry.id === selectedEntryId
      );
      console.log("📗 Found Register Entry:", fullEntry);

      if (!fullEntry) {
        throw new Error("Register entry not found in returned register");
      }

      const newSignalData = {
        id: crypto.randomUUID(),
        created: new Date().toISOString(),
        name: fullEntry.name || "",
        description: fullEntry.description || "",
        type: fullEntry.type || "",
        classCode: fullEntry.classCode || "",
        objectType: fullEntry.objectType || "",
        references: fullEntry.references || [],
        classifications: fullEntry.classifications || [],
        amounts: fullEntry.amounts || [],
        dateTimes: fullEntry.dateTimes || [],
        parties: fullEntry.parties || [],
        addresses: fullEntry.addresses || [],
        text: fullEntry.text || [],
      };

      console.log("✅ Adding signalData:", newSignalData);
      setSignalDataArray((prev) => [...prev, newSignalData]);
    } catch (err) {
      console.error("❌ Error during template load:", err);
      toast({
        title: "Failed to load template",
        description: err.message,
        status: "error",
      });
    }
  };

  return (
    <Box
      p="2"
      mb="4"
      borderWidth="1px"
      borderRadius="md"
      borderColor="gray.200"
      backgroundColor="whiteAlpha.800">
      <Text fontWeight="bold" fontStyle="italic" fontSize="lg">
        Signal Data Templates
      </Text>

      <HStack>
        <Select
          width="300px"
          placeholder="Select Register"
          isDisabled={registerLoading}
          value={selectedRegisterId}
          onChange={(e) => setSelectedRegisterId(e.target.value)}>
          {registers.map((reg) => (
            <option key={reg._id} value={reg._id}>
              {reg.name}
            </option>
          ))}
        </Select>

        <Select
          width="300px"
          placeholder="Select Register Entry"
          isDisabled={registerLoading || !selectedRegisterId}
          value={selectedEntryId}
          onChange={(e) => setSelectedEntryId(e.target.value)}>
          {selectedRegisterId &&
            registers
              .find((reg) => reg._id === selectedRegisterId)
              ?.entries.map((entry) => (
                <option key={entry.id} value={entry.id}>
                  {entry.name}
                </option>
              ))}
        </Select>

        <Tooltip label="Select Template">
          <IconButton
            icon={<FaChevronCircleDown />}
            onClick={handleSelectTemplate}
          />
        </Tooltip>
      </HStack>
    </Box>
  );
};

export default RegisterEntrySelect;
